import styled from 'styled-components';
import breakpoint from 'components/utils/responsive';
import { colorToken } from "components/utils/constants";

export default styled.div`
    min-height: 100vh;
    display: flex;
    padding-top: 95px;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    background-image: url('/assets/img/bg-interna.jpg');
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    
    img {
        max-width: 100%;
    }
    @media ${breakpoint.md} {
        padding-top: 100px;
        /* flex-basis: 50%;
        flex-direction: row; */
    }
`;

export const StyleContentWrapper = styled.div`
    display: flex;
    flex-direction: column;
    transition: max-height linear 0.2s;
    align-items: center;
    width: 100%;
    flex-grow: 1;
    padding: 0 12px;
        
    justify-content: space-between;
    > div:last-of-type {
        text-align: center;
         padding-bottom: 12px;
    }
    p{
        color: ${colorToken.white};
        text-align: center;
        padding: 0 16px;
        margin-bottom: 16px;
    }
    @media ${breakpoint.md} {
        /* flex-basis: 50%;
        flex-direction: row; */
        p{
            width: 65%;
            margin: 0 auto 12px;
           
        }
    }

`;

export const StyleTitlePage = styled.h3`
    font-size: 2.2rem;
    color: ${colorToken.color1};
    font-weight: bold;
    text-align: center;
    width: 100%;
    max-width: 950px;
    margin: 0 auto;
    padding-bottom: 16px;
`;

export const StyleRegulamentoWrapper = styled.div`
  background-color: white;
  max-width: 950px;
  margin: 0 auto;
  height: calc(100vh - 230px);
  color: ${colorToken.black};
  padding: 12px;
  font-size: 1.2rem;
  overflow: auto;

  border-radius: 8px;
  border: 2px solid ${colorToken.color1};
  width: 100%;
  h1{
    font-size: 1.6rem;
    font-weight: bold;
  }
  p{
          color: ${colorToken.black};
        text-align: unset;
        padding: 0;
        margin: 0 0 12px;
        width: 100%;
    }
  @media ${breakpoint.md} {
    height: calc(100vh - 220px);
  }
`;

export const StyleRegulamentoContent = styled.div`
  img{
    max-width: 100%;
  }
`;